export enum MAPTYPES {
  STREET = 'https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',
  HYBRID = 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
  SATELLITE = 'https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
  TERRAIN = 'https://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}',
}